import type { ReactNode } from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import WaveBackground from '../marketing/WaveBackground';

interface PublicLayoutProps {
  children: ReactNode;
  activeSubjectRoute?: string;
  showWaves?: boolean;
  showFooterCompanyDetails?: boolean;
}

export default function PublicLayout({
  children,
  activeSubjectRoute,
  showWaves = true,
  showFooterCompanyDetails = false,
}: PublicLayoutProps) {
  return (
    <div
      className="public-layout"
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--gradient-page)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {showWaves ? <WaveBackground /> : null}
      <PublicHeader activeSubjectRoute={activeSubjectRoute} />
      <main className="public-main" style={{ flex: 1, position: 'relative', zIndex: 1, width: '100%' }}>
        {children}
      </main>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <PublicFooter showCompanyDetails={showFooterCompanyDetails} />
      </div>
    </div>
  );
}
